{
  "GHG Impacts": {
    "equation": [
      {
        "key": "in_u_elementary.amount",
        "note": "In case you need further explanation on the subject, Customer recommends that you follow the standard from the <a aria-label='GHG Protocol' target='_blank' href='https://ghgprotocol.org/'>GHG Protocol</a>.",
        "more_info": [
          {
            "description": "Submit the emissions of all the fuel that the company site has burned onsite (Scope 1) and"
          },
          {
            "description": "Submit the emissions tied to the purchased electricity, steam, heating or cooling from an energy utility (Scope 2)."
          }
        ]
      },
      {
        "key": "total_co2",
        "note": "NB: The submitted data in this question is expected to be the sum of GHG emissions of electricity, heat, and fuels.",
        "more_info": [
          {
            "label": "Direct measurement",
            "description": "Direct measurement of “total GHG emissions for products delivered to Customer”. This method necessitates that your company only has one production line or can measure Customer-specific production lines."
          },
          {
            "label": "Weight ",
            "description": "Weight of products delivered to Customer divided by the total weight of products produced by the company site, or similar physically based process-allocation to find the share of weight of products delivered to Customer. This share should then be used as the same share for the allocation of total GHG emissions for the products delivered to Customer.",
            "formula": [
              {
                "type" : "img",
                "icon": "union",
                "formula": "A/B = C"
              },
              {
                "type" : "text",
                "formula": "D*C = GHG emissions related to products delivered to Customer"
              }
            ],
            "legends": [
              {
                "label": "A",
                "value": "Weight of products delivered to Customer"
              },
              {
                "label": "B",
                "value": "Total weight of products produced by the company site"
              },
              {
                "label": "C",
                "value": "Percentage share of weight of products delivered to Customer"
              },
              {
                "label": "D",
                "value": "Total GHG emissions by the company site"
              }
            ]
          },
          {
            "label": "Revenue ",
            "description": "Revenue of products delivered to Customer divided by the total revenue of the company site to find the share of revenue of products delivered to Customer. This share should then be used as the same share for the allocation of total GHG emissions for the products delivered to Customer.",
            "formula": [
              {
                "type" : "img",
                "icon": "union",
                "formula": "A/B = C"
              },
              {
                "type" : "text",
                "formula": "D*C = GHG emissions related to products delivered to Customer"
              }
            ],
            "legends": [
              {
                "label": "A",
                "value": "Revenue of products delivered to Customer"
              },
              {
                "label": "B",
                "value": "Total revenue of products produced by the company site"
              },
              {
                "label": "C",
                "value": "Percentage share of revenue of products delivered to Customer"
              },
              {
                "label": "D",
                "value": "Total GHG emissions by the company site"
              }
            ]
          }
        ]
      }
    ]
  },
  "Electricity": {
    "equation": [
      {
        "key": "in_u_elementary.amount",
        "note": "NB: After using a chosen allocation method, the amount of electricity consumption identified should then be multiplied by emission factors for electricity to find the GHG emissions tied to products delivered to Customer.",
        "more_info": [
          {
            "label": "Direct measurement",
            "description": "Direct measurement of “total GHG emissions for products delivered to Customer”. This method necessitates that your company only has one production line or can measure Customer-specific production lines."
          },
          {
            "label": "Weight",
            "description": "Weight of products delivered to Customer divided by the total weight of products produced by the company site, or similar physically based process-allocation to find the share of weight of products delivered to Customer. This share should then be used as the same share for the allocation of electricity consumption for the products delivered to Customer.",
            "formula": [
              {
                "type" : "img",
                "icon": "union",
                "formula": "A/B = C"
              },
              {
                "type" : "text",
                "formula": "D*C = Electricity consumption related to products delivered to Customer"
              }
            ],
            "legends": [
              {
                "label": "A",
                "value": " Weight of products delivered to Customer"
              },
              {
                "label": "B",
                "value": "Total weight of products produced by the company site"
              },
              {
                "label": "C",
                "value": "Percentage share of weight of products delivered to Vesta"
              },
              {
                "label": "D",
                "value": "Total electricity consumption by the company site"
              }
            ]
          },
          {
            "label": "Revenue",
            "description": "Revenue of products delivered to Customer divided by the total revenue of the company site to find the share of revenue of products delivered to Customer. This share should then be used as the same share for the allocation of total GHG emissions for the products delivered to Customer.",
            "formula": [
              {
                "type" : "img",
                "icon": "union",
                "formula": "A/B = C"
              },
              {
                "type" : "text",
                "formula": "D*C = Electricity consumption related to products delivered to Customer"
              }
            ],
            "legends": [
              {
                "label": "A",
                "value": "Revenue of products delivered to Customer"
              },
              {
                "label": "B",
                "value": "Total revenue of products produced by the company site"
              },
              {
                "label": "C",
                "value": "Percentage share of revenue of products delivered to Customer"
              },
              {
                "label": "D",
                "value": "Total electricity consumption by the company site"
              }
            ]
          }
        ]
      }
    ]
  },
  "Heat": {
    "equation": [
      {
        "key": "in_u_elementary.amount",
        "note": "NB: After using a chosen allocation method, the amount of heat consumption identified should then be multiplied by emission factors for heat to find the GHG emissions tied to products delivered to Customer.",
        "more_info": [
          {
            "label": "Direct measurement",
            "description": "Direct measurement of “heat consumption for products delivered to Customer”. This method necessitates that your company only has one production line or can measure Customer-specific production lines."
          },
          {
            "label": "Weight",
            "description": "Weight of products delivered to Customer divided by the total weight of products produced by the company site, or similar physically based process-allocation to find the share of weight of products delivered to Customer. This share should then be used as the same share for the allocation of heat consumption for the products delivered to Customer. ",
            "formula": [
              {
                "type" : "img",
                "icon": "union",
                "formula": "A/B = C"
              },
              {
                "type" : "text",
                "formula": "D*C = Heat consumption related to products delivered to Customer"
              }
            ],
            "legends": [
              {
                "label": "A",
                "value": "Weight of products delivered to Customer"
              },
              {
                "label": "B",
                "value": "Total weight of products produced by the company site"
              },
              {
                "label": "C",
                "value": "Percentage share of weight of products delivered to Customer"
              },
              {
                "label": "D",
                "value": "Total heat consumption by the company site"
              }
            ]
          },
          {
            "label": "Revenue",
            "description": "Revenue of products delivered to Customer divided by the total revenue of the company site to find the share of revenue of products delivered to Customer. This share should then be used as the same share for the allocation of total GHG emissions for the products delivered to Customer.",
            "formula": [
              {
                "type" : "img",
                "icon": "union",
                "formula": "A/B = C"
              },
              {
                "type" : "text",
                "formula": "D*C = Heat consumption related to products delivered to Customer"
              }
            ],
            "legends": [
              {
                "label": "A",
                "value": "Revenue of products delivered to Customer"
              },
              {
                "label": "B",
                "value": "Total revenue of products produced by the company site"
              },
              {
                "label": "C",
                "value": "Percentage share of revenue of products delivered to Customer"
              },
              {
                "label": "D",
                "value": "Total heat consumption by the company site"
              }
            ]
          }
        ]
      }
    ]
  },
  "Fuels": {
    "equation": [
      {
        "key": "in_u_elementary.amount",
        "note": "NB: After using a chosen allocation method, the amount of fuel consumption identified should then be multiplied by emission factors for fuels to find the GHG emissions tied to products delivered to Customer.",
        "more_info": [
          {
            "label": "Direct measurement",
            "description": "Direct measurement of “fuel consumption for products delivered to Customer”. This method necessitates that your company only has one production line or can measure Customer-specific production lines."
          },
          {
            "label": "Weight",
            "description": "Weight of products delivered to Customer divided by the total weight of products produced by the company site, or similar physically based process-allocation to find the share of weight of products delivered to Customer. This share should then be used as the same share for the allocation of fuel consumption for the products delivered to Customer. ",
            "formula": [
              {
                "type" : "img",
                "icon": "union",
                "formula": "A/B = C"
              },
              {
                "type" : "text",
                "formula": "D*C = Fuel consumption related to products delivered to Customer"
              }
            ],
            "legends": [
              {
                "label": "A",
                "value": "Weight of products delivered to Customer"
              },
              {
                "label": "B",
                "value": "Total weight of products produced by the company site"
              },
              {
                "label": "C",
                "value": "Percentage share of weight of products delivered to Customer"
              },
              {
                "label": "D",
                "value": "Total fuel consumption by the company site"
              }
            ]
          },
          {
            "label": "Revenue",
            "description": "Revenue of products delivered to Customer divided by the total revenue of the company site to find the share of revenue of products delivered to Customer. This share should then be used as the same share for the allocation of total GHG emissions for the products delivered to Customer. ",
            "formula": [
              {
                "type" : "img",
                "icon": "union",
                "formula": "A/B = C"
              },
              {
                "type" : "text",
                "formula": "D*C = Fuel consumption related to products delivered to Customer"
              }
            ],
            "legends": [
              {
                "label": "A",
                "value": "Revenue of products delivered to Customer"
              },
              {
                "label": "B",
                "value": "Total revenue of products produced by the company site"
              },
              {
                "label": "C",
                "value": "Percentage share of revenue of products delivered to Customer"
              },
              {
                "label": "D",
                "value": "Total fuel consumption by the company site"
              }
            ]
          }
        ]
      }
    ]
  }
}
